export const paths = {
  login: "/login",
  dashboard: "/",
  contracts: "/contracts",
  contractNew: "/contracts/new",
  contractDetail: (id: string | number) => `/contracts/${id}`,
  contractEdit: (id: string | number) => `/contracts/${id}/edit`,
  contractOrderNew: (id: string | number) => `/contracts/${id}/orders/new`,
  orders: "/orders",
  orderDetail: (id: string | number) => `/orders/${id}`,
  orderEdit: (id: string | number) => `/orders/${id}/edit`,
  reception: "/reception",
  receptionDetail: (id: string | number) => `/reception/${id}`,
  deliveryFormDetail: (id: string | number) => `/delivery-forms/${id}`,
  millFloor: "/mill-floor",
  usinageDetail: (id: string | number) => `/mill-floor/${id}`,
  lots: "/lots",
  lotDetail: (id: string | number) => `/lots/${id}`,
  transitOrders: "/transit-orders",
  transitOrderDetail: (id: string | number) => `/transit-orders/${id}`,
  transitOrderTraceability: (id: string | number) =>
    `/transit-orders/${id}/traceability`,
  publicShare: (code: string) => `/share/ot/${code}`,
  documentDelivery: "/document-delivery",
  clients: "/clients",
  cooperatives: "/cooperatives",
  cooperativeDetail: (id: string | number) => `/cooperatives/${id}`,
  usersRoles: "/users-roles",
} as const
